import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import OccasionCollectionsPage from "./occasion-collections-page";

export default (
  <Route path="occasion-collections">
    <Route
      index
      element={
        <Protected
          path="/admin/occasion-collections"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <OccasionCollectionsPage />
        </Protected>
      }
    />
  </Route>
);
